import React from "react";
import Coinpayments from 'coinpayments';
import axios from 'axios';
import { Mutation } from "react-apollo";
import { ADD_NEW_OFFER } from "../../../queries";
import { ADD_PAYPAL_REQUEST, ADD_PAYEER_REQUEST } from "../../../queries";
import ArnoGold from "../../../img/IndexMain/arty-gold.png";
import Payeer from "../Offers/Payeer";
import check from "../../../img/IndexMain/check.svg";
import { offerLang } from "./offerLang";

function SHA1(s){
 
	var chrsz   = 8;
	var hexcase = 0;
 
	function safe_add (x, y) {
		var lsw = (x & 0xFFFF) + (y & 0xFFFF);
		var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
		return (msw << 16) | (lsw & 0xFFFF);
	}
 
	function S (X, n) { return ( X >>> n ) | (X << (32 - n)); }
	function R (X, n) { return ( X >>> n ); }
	function Ch(x, y, z) { return ((x & y) ^ ((~x) & z)); }
	function Maj(x, y, z) { return ((x & y) ^ (x & z) ^ (y & z)); }
	function Sigma0256(x) { return (S(x, 2) ^ S(x, 13) ^ S(x, 22)); }
	function Sigma1256(x) { return (S(x, 6) ^ S(x, 11) ^ S(x, 25)); }
	function Gamma0256(x) { return (S(x, 7) ^ S(x, 18) ^ R(x, 3)); }
	function Gamma1256(x) { return (S(x, 17) ^ S(x, 19) ^ R(x, 10)); }
 
	function core_sha256 (m, l) {
		var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2);
		var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
		var W = new Array(64);
		var a, b, c, d, e, f, g, h, i, j;
		var T1, T2;
 
		m[l >> 5] |= 0x80 << (24 - l % 32);
		m[((l + 64 >> 9) << 4) + 15] = l;
 
		for ( var i = 0; i<m.length; i+=16 ) {
			a = HASH[0];
			b = HASH[1];
			c = HASH[2];
			d = HASH[3];
			e = HASH[4];
			f = HASH[5];
			g = HASH[6];
			h = HASH[7];
 
			for ( var j = 0; j<64; j++) {
				if (j < 16) W[j] = m[j + i];
				else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
 
				T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
				T2 = safe_add(Sigma0256(a), Maj(a, b, c));
 
				h = g;
				g = f;
				f = e;
				e = safe_add(d, T1);
				d = c;
				c = b;
				b = a;
				a = safe_add(T1, T2);
			}
 
			HASH[0] = safe_add(a, HASH[0]);
			HASH[1] = safe_add(b, HASH[1]);
			HASH[2] = safe_add(c, HASH[2]);
			HASH[3] = safe_add(d, HASH[3]);
			HASH[4] = safe_add(e, HASH[4]);
			HASH[5] = safe_add(f, HASH[5]);
			HASH[6] = safe_add(g, HASH[6]);
			HASH[7] = safe_add(h, HASH[7]);
		}
		return HASH;
	}
 
	function str2binb (str) {
		var bin = Array();
		var mask = (1 << chrsz) - 1;
		for(var i = 0; i < str.length * chrsz; i += chrsz) {
			bin[i>>5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i%32);
		}
		return bin;
	}
 
	function Utf8Encode(string) {
		string = string.replace(/\r\n/g,"\n");
		var utftext = "";
 
		for (var n = 0; n < string.length; n++) {
 
			var c = string.charCodeAt(n);
 
			if (c < 128) {
				utftext += String.fromCharCode(c);
			}
			else if((c > 127) && (c < 2048)) {
				utftext += String.fromCharCode((c >> 6) | 192);
				utftext += String.fromCharCode((c & 63) | 128);
			}
			else {
				utftext += String.fromCharCode((c >> 12) | 224);
				utftext += String.fromCharCode(((c >> 6) & 63) | 128);
				utftext += String.fromCharCode((c & 63) | 128);
			}
 
		}
 
		return utftext;
	}
 
	function binb2hex (binarray) {
		var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
		var str = "";
		for(var i = 0; i < binarray.length * 4; i++) {
			str += hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8+4)) & 0xF) +
			hex_tab.charAt((binarray[i>>2] >> ((3 - i%4)*8  )) & 0xF);
		}
		return str;
	}
 
	s = Utf8Encode(s);
	return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
 
}

class GoldOffer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reload: this.props.reload,
            hover: false,
            SumGold: '',
            CurrenCourse: 0.28,
            PaymentCoinSum: 0,
            valueUSD: 0,
            SITE_ADDRESS: "https://launch.artyfact.game",
            email: this.props.session.email,
            agent: this.props.session.Agent,
            fullname: this.props.session.Name + ' ' + this.props.session.Surname,
            currency1: 'USD',
            currency2: 'BNB.BSC',
            OfferName: 'Gold package',
            item: 'Buying ARTY coins',
            ViewCurrency: 'BNB',
            MerchSettings: {
                key: 'c8e54fba20a1c47b0e21494ba62543ee80f9bb188a5fad86a08d7026d7d12fef',
                secret: '1cC2A94dd651787F88c60fF81036905e7D9339b923D699d6bb2bB83Ad57e3F45'
            },
            CoinpaymentsRatesOpts: {
                short: 1,
                accepted: 2
            },
            rates: {},
            request_id: '',
            status: 0,
            Transaction: '',
            sending: false,

            //PayPal
            clientID: 'fake', //real
            secretKey: 'fake', //real
            hostname: 'api.paypal.com',
            sendRequest: false,
            paidReq: false,
            accessToken: null,
            name: this.props.session.Name,
            surname: this.props.session.Surname,
            requestID: '',
            requestStatus: '',
            requestLink: '',
            captureID: false,

            //Payeer
            payeerMerch: '1287030968',
            payeerSecret: '123',
            payeerCurr: 'USD',
            requestPayeerID: '',
            requestPayeerLink: '',
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        };
        
        this.ChangeElement = this.ChangeElement.bind(this);
        this.ChangeElement2 = this.ChangeElement2.bind(this);
        this.SumValidate = this.SumValidate.bind(this);
        this.UpdateRates = this.UpdateRates.bind(this);
        this.BuyPackage = this.BuyPackage.bind(this);
    }

    async componentDidMount(){
        let CetRates = await axios.post(`${this.state.SITE_ADDRESS}/getrates`, this.state.CoinpaymentsRatesOpts);
        if (CetRates.data){
            this.setState({rates: CetRates});
            this.GetRates(this.state.SumGold, this.state.currency2);
            setInterval(this.UpdateRates, 60 * 1000);
        }

        //Get ARNO price 
        /*let PriceARNO = await axios.get('https://api.indoex.io/getSelectedMarket/ARNO_USDT');
        if (PriceARNO) {
            this.setState({CurrenCourse: PriceARNO.data.marketdetails[0].last});
        }*/

        //PayPal
        let self = this;
        await axios.request({
            url: `https://${this.state.hostname}/v1/oauth2/token`,
            method: "post",
            headers:{
                Accept: "application/json",
                "Accept-Language": "en_US",
                "Content-Type": "application/x-www-form-urlencoded"
            },
            auth: {
              username: this.state.clientID,
              password: this.state.secretKey
            },
            params: {
                grant_type: 'client_credentials'
            }
        }).then(res => {
            self.setState({accessToken: res.data.access_token});
        });
    }

    async UpdateRates() {
        let CetRates = await axios.post(`${this.state.SITE_ADDRESS}/getrates`, this.state.CoinpaymentsRatesOpts);
        if (CetRates.data){
            this.setState({rates: CetRates});
            this.GetRates(this.state.SumGold, this.state.currency2);
        }
    }

    GetRates(val, currency) {
        let rates = this.state.rates;
        let curCurse = this.state.CurrenCourse;
        if (currency == 'paypal' || currency == 'payeer') {
            this.setState({PaymentCoinSum : (val * curCurse).toFixed(5) });
        } else {      
            if (rates.data) {            
                let CostBTC = 1/(rates.data.USD.rate_btc);            
                let BTCsum = rates.data.USD.rate_btc * this.state.CurrenCourse * val;            
                let CostCurCoin = BTCsum/rates.data[`${currency}`].rate_btc; 
                this.setState({PaymentCoinSum: CostCurCoin.toFixed(5)});
            }
        }
    }

    ChangeElement = event => {
        let value = event.target.value.replace(/[^1234567890]/g, ''); // Я убираю все буквы (не даю их вводить)

        let valueArno = value / this.state.CurrenCourse;
        //if (value.length >= 3) {
        //    if (value < 400) { value = 400; } 
        //    this.setState({SumGold : valueArno.toFixed(5), valueUSD: value});
        //} else {
            this.setState({SumGold : valueArno.toFixed(5), valueUSD: value});
        //} 
        this.GetRates(valueArno.toFixed(5), this.state.currency2);              
    };    

    SumValidate = event => {
        let validate = true;
        if (+this.state.valueUSD < 10000) {
            validate = false;
        }
        return validate;
    }; 
    
    ChangeElement2 = event => {
        let value = event.target.value;
        this.setState({currency2 : value, ViewCurrency: value});        
        if (value == 'BUSD.BEP20') { this.setState({ViewCurrency : 'BUSD'}) }
        if (value == 'USDT.BEP20') { this.setState({ViewCurrency : 'USDT'}) }
        if (value == 'USDT.TRC20') { this.setState({ViewCurrency : 'USDT'}) }
        this.GetRates(this.state.SumGold, value);
    };

    async BuyPackage(event, newWindow) {
        event.preventDefault(); 
        this.setState({sending : true});
        const client = new Coinpayments(this.state.MerchSettings);
        let CoinpaymentsCreateTransactionOpts = {
            currency1: this.state.currency1,
            currency2: this.state.currency2,
            amount: this.state.SumGold * this.state.CurrenCourse,
            buyer_email: this.state.email,
            buyer_name: this.state.fullname,
            item_name: this.state.OfferName,
            custom: this.state.item,
            success_url: `${this.state.SITE_ADDRESS}/withdrawal`,
            cancel_url: `${this.state.SITE_ADDRESS}/withdrawal`
        };
        const Transaction = await axios.post(`${this.state.SITE_ADDRESS}/transaction`, CoinpaymentsCreateTransactionOpts);
        if (Transaction.data) {
            //console.log(Transaction.data);
            this.setState({Transaction: Transaction.data, request_id: Transaction.data.txn_id});
            newWindow.location = Transaction.data.checkout_url;
            document.getElementById('PayButton3').click();
        }
    }

    addNewOfferEvent = (event, addNewOffer) => {
        event.preventDefault();        
        //window.open(`${this.state.Transaction.checkout_url}`, '_blank');
        addNewOffer().then(({ data }) => {
            console.log('addNewOffer', data.addNewOffer);
            this.setState({sending : false});
            
            if (this.state.reload) {
                window.open(`${this.state.SITE_ADDRESS}/withdrawal`, '_top');
            }
        })
    };  

    //PayPal
    BuyPayPal = (event, newWindow) => {
        event.preventDefault();
        this.setState({sending : true});

        axios.post(`https://${this.state.hostname}/v2/checkout/orders`,
                {
                    "intent": "CAPTURE",
                    "purchase_units": [
                        {   
                            "description": "Payment for crediting ARTY tokens to your personal account on the website https://artyfact.game",
                            "amount": {
                                "currency_code": "USD",
                                "value": `${this.state.PaymentCoinSum}`
                            }
                        }
                    ],
                    "payer": {
                        "name": {
                          "given_name": `${this.state.name}`,
                          "surname": `${this.state.surname}`
                        },
                        "email_address": `${this.state.email}`
                    },
                    "application_context" : {
                        "brand_name": "ARTY",
                        "user_action": "PAY_NOW",
                        "shipping_preference": "NO_SHIPPING",
                        "return_url": `${this.state.SITE_ADDRESS}/withdrawal`,
                        "cancel_url": this.state.SITE_ADDRESS
                    }
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.accessToken}`
                    }
                }
            ).then(res => {
                let requestLink = res.data.links.find(data => data.rel == "approve").href;
                this.setState({
                    requestID: res.data.id,
                    requestStatus: res.data.status,
                    requestLink: requestLink,
                    paidReq: true
                });
                newWindow.location = requestLink;
                document.getElementById('PayButtonPayPal3').click();
            });
    }

    addPayPal = (event, addPayPalRequest) => {
        event.preventDefault();
        //window.open(`${this.state.requestLink}`, '_blank');
        addPayPalRequest().then(({ data }) => {
            this.setState({sending : false});
    
            console.log('addPayPalRequest работает', data.addPayPalRequest);
            this.setState({ sendRequest: true });
            if (this.state.reload) {
                window.open(`${this.state.SITE_ADDRESS}/withdrawal`, '_top');
            }
        })
    };  

    //Payeer
    BuyPayeer = event => {
        event.preventDefault();
        this.setState({sending : true});

        let payeerAPI = new Payeer(this.state.payeerMerch , this.state.payeerSecret, this.state.payeerCurr);
        let paeerIDreq = `${Date.now()}`.slice(8);
        
        const promise = new Promise((resolve, reject) => {
            let payeerLink = payeerAPI.getLinkToPay(paeerIDreq, this.state.PaymentCoinSum, 'Payment for crediting ARNO tokens to your personal account on the website https://arno-token.com');
            if(payeerLink) {
                resolve(payeerLink);
            } else {
                reject(new Error('Что-то пошло не так'));
            }
        });

        promise.then((data) => {
            this.setState({requestPayeerID: paeerIDreq, requestPayeerLink: data});
            document.getElementById('PayButtonPayeer3').click();
        });
    }

    addPayeer = (event, addPayeerRequest) => {
        event.preventDefault();
        window.open(`${this.state.requestPayeerLink}`, '_blank');
        addPayeerRequest().then(({ data }) => {
            this.setState({sending : false});
            
            console.log('addPayeerRequest работает', data.addPayeerRequest);
            this.setState({ sendRequest: true });
            if (this.state.reload) {
                window.open(`${this.state.SITE_ADDRESS}/withdrawal`, '_top');
            }
        })
    };  

    handleMouseIn() {
        this.setState({ hover: true })
    }
      
    handleMouseOut() {
        this.setState({ hover: false })
    }

    handeNotSaleClick() {
        this.setState({ hover: !this.state.hover })
    }

    render() {
        const tooltipStyle = {
            display: this.state.hover ? 'block' : 'none'
        }
        return (
            <div class="package-area2">
                {this.state.Language == 'ru' ? (
                    <div className="package-ttl2 starzone" style={{'letter-spacing': '0', 'width': '166px', 'padding-left': '25px'}}>
                        <img className="package-img2" src={ArnoGold} /> {offerLang.gold[this.state.Language]}
                    </div>
                ) : (
                    <div className="package-ttl2 starzone" style={{'padding-left': '25px'}}>
                        <img className="package-img2" src={ArnoGold} /> {offerLang.gold[this.state.Language]}
                    </div>
                )}  

                <div className="package-price2">
                    <input className="SumInputDash2" type="text" value={this.state.valueUSD ? this.state.valueUSD : ''} name="valueUSD" placeholder={offerLang.enter_amount[this.state.Language]} onChange={this.ChangeElement}/>
                    <div className="package-price-text2">USD</div>
                    <div className="help-sum">{this.state.valueUSD < 10000 && offerLang.minimum10000[this.state.Language] }</div>
                </div>

                <div className="custom-separator"></div>

                <div className="payment-type-area">
                    <div className="PaymentCoin2">
                        {offerLang.payment_coin[this.state.Language]}
                    </div>
                    <div className="PaymentSelection2">
                        <label>
                            <select value={this.state.currency2 ? this.state.currency2 : ''} className="selectCoinBox" name="currency2" onChange={this.ChangeElement2}>           
                                <option value="BNB.BSC">BNB (BEP20)</option>
                                <option value="BTC">BTC</option>
                                <option value="ETH">ETH (ERC20)</option> 
                                <option value="ETH.BEP20">ETH (BEP20)</option>                                                                
                                <option value="BUSD.BEP20">BUSD (BEP20)</option>  
                                <option value="USDC">USDC (ERC20)</option>     
                                <option value="USDC.BEP20">USDC (BEP20)</option>                          
                                <option value="USDT.BEP20">USDT (BEP20)</option>
                                <option value="USDT.TRC20">USDT (TRC20)</option>
                                <option value="LTC">LTC</option>
                                {/*<option value="paypal">PayPal</option>
                                <option value="payeer">Payeer</option>*/}
                            </select>
                        </label>
                    </div>
                </div>

                <div className="PaymentCoinSum2">
                   = {this.state.PaymentCoinSum} {this.state.ViewCurrency == 'BNB.BSC' ? 'BNB' : this.state.ViewCurrency}
                   {/* {this.state.currency2 == 'paypal' || this.state.currency2 == 'payeer' ? 'USD' : this.state.currency2} */}
                </div> 

                <ul class="list-package">
                    <li class="mb-3">
                        <img className="check-img" src={check}/> {offerLang.from[this.state.Language]} 10000 USD
                    </li>
                    <li class="mb-3">
                        <img className="check-img" src={check}/> {offerLang.bonus5[this.state.Language]}
                    </li>
                </ul>
               
                <div className="total-arno">
                    {offerLang.total_bonus[this.state.Language]}
                </div>
                <div className="total-arno-sum">
                    {(this.state.valueUSD && this.state.valueUSD >= 10000) && '= ' + (this.state.SumGold * 1.05).toFixed(2)} $ARTY
                </div>

                { this.SumValidate() ? (
                    <>
                    { this.state.sending ? (
                        <div class="package-but buy-botton" id="gold-bot-dis">
                            {offerLang.wait[this.state.Language]}
                        </div>
                    ) : (
                        <>
                        { this.state.currency2 == 'paypal' ? ( 
                            <div id="gold-bot-paypal" className="package-but buy-botton" 
                                onClick={event => {let newWindow = window.open("", "_blank"); this.BuyPayPal(event, newWindow)}}>
                                {offerLang.buy[this.state.Language]} $ARTY
                            </div>
                        ) : (
                            <>
                            { this.state.currency2 == 'payeer' ? (
                                <div id="gold-bot-payeer" className="package-but buy-botton" onClick={event => this.BuyPayeer(event)}>
                                    {offerLang.buy[this.state.Language]} $ARTY
                                </div>
                            ) : (
                                <>
                                <a href="https://launchpad.artyfact.game" className="package-but buy-botton" style={{"display": "block", "textDecoration": "none"}} target="_blank">{offerLang.buy[this.state.Language]} $ARTY</a>
                                {/* <div id="gold-bot" className="package-but buy-botton"
                                    onClick={event => {let newWindow = window.open("", "_blank"); this.BuyPackage(event, newWindow)}}>
                                    {offerLang.buy[this.state.Language]} $ARTY
                                </div> */}
                                </>
                            )}
                            </>
                            
                        )}
                        <div id="gold-bot-dis" class="package-but buy-botton hidden">
                            {offerLang.wait[this.state.Language]}
                        </div>
                        </>
                    )}
                    <Mutation mutation={ADD_NEW_OFFER} variables={{ 
                        email: this.state.email,
                        agent: this.state.agent ? this.state.agent : '',
                        arno: +this.state.SumGold,
                        ammount: this.state.SumGold * this.state.CurrenCourse,
                        coin_ammount: +this.state.Transaction.amount,
                        status: SHA1(this.state.email + +this.state.SumGold + this.state.request_id + this.state.currency2),//this.state.status,
                        request_id: this.state.request_id,
                        item_name: this.state.OfferName,
                        currency1: this.state.currency1,
                        currency2: this.state.currency2,
                        status_url: this.state.Transaction.status_url,                        
                        payment_time: new Date()
                        }}>
                        {(addNewOffer, { data, loading, error }) => {
                            return (
                                <>                                    
                                    <button id="PayButton3" style={{ display: 'none' }} onClick={event => this.addNewOfferEvent(event, addNewOffer)}>Make deposit</button>
                                </>
                            )
                        }}
                    </Mutation>

                    <Mutation mutation={ADD_PAYPAL_REQUEST} variables={{ 
                        email: this.state.email,
                        agent: this.state.agent ? this.state.agent : '',
                        arno: +this.state.SumGold,
                        value: this.state.SumGold * this.state.CurrenCourse, 
                        currency: 'USD',
                        request_id: this.state.requestID,
                        item_name: this.state.OfferName,
                        status: SHA1(this.state.email + +this.state.SumGold + this.state.requestID + this.state.OfferName),//this.state.requestStatus,
                        intent: 'CAPTURE',
                        create_time: new Date(),
                        pay_link: this.state.requestLink}}>
                        {(addPayPalRequest, { data, loading, error }) => {
                            return (
                                <div style={{ display: 'none' }} >                                    
                                    <button id="PayButtonPayPal3" onClick={event => this.addPayPal(event, addPayPalRequest)} className="ButtonStandart">Make deposit</button>                                    
                                </div>
                            )
                        }}
                    </Mutation>

                    <Mutation mutation={ADD_PAYEER_REQUEST} variables={{ 
                        email: this.state.email,
                        agent: this.state.agent ? this.state.agent : '',
                        arno: +this.state.SumGold,
                        value: this.state.SumGold * this.state.CurrenCourse, 
                        currency: this.state.payeerCurr,
                        request_id: this.state.requestPayeerID,
                        item_name: this.state.OfferName,
                        status: SHA1(this.state.email + +this.state.SumGold + this.state.requestPayeerID + this.state.OfferName),//this.state.requestStatus,'pending',
                        create_time: new Date(),
                        pay_link: this.state.requestPayeerLink}}>
                        {(addPayeerRequest, { data, loading, error }) => {
                            return (
                                <div style={{ display: 'none' }} >                                    
                                    <button id="PayButtonPayeer3" onClick={event => this.addPayeer(event, addPayeerRequest)} className="ButtonStandart">Make deposit</button>                                    
                                </div>
                            )
                        }}
                    </Mutation>
                    </>
                ) : (
                    <div className="package-but-disable buy-botton" onMouseOver={this.handleMouseIn.bind(this)} onMouseOut={this.handleMouseOut.bind(this)} onClick={this.handeNotSaleClick.bind(this)}>
                        <div className="tooltipArea" style={tooltipStyle}>{offerLang.notsale[this.state.Language]}</div>
                        {offerLang.buy[this.state.Language]} $ARTY
                    </div>
                )}                
            </div>
        )
    }
}

export default GoldOffer